import React from 'react';
import { Camera } from 'lucide-react';

// Consignes de prise de vue pour un avant/après (2026-09-10, Emeni) : un avant/après ne « ressort » que
// si les deux photos sont prises de la même façon. Sans consignes, le salarié cadre l'avant de loin et
// l'après de près, et le curseur du widget public compare deux images qui n'ont rien à voir.
// Affichées partout où l'on prend ou dépose ces photos : à la clôture d'un rendez-vous, et à l'ajout
// manuel d'une réalisation.
const CONSIGNES: { titre: string; detail: string }[] = [
    { titre: 'Même endroit, même angle', detail: 'Restez au même point pour les deux photos, l\'appareil à la même hauteur, face à l\'objet.' },
    { titre: 'Même distance', detail: 'L\'objet doit occuper la même place dans le cadre sur les deux photos. Repérez un détail fixe — un coin de mur, un pied de meuble — et gardez-le au même endroit.' },
    { titre: 'L\'objet en entier', detail: 'Tout le canapé, tout le tapis, tout le matelas dans l\'image, avec un peu de marge autour.' },
    { titre: 'Même lumière', detail: 'Rideaux et lampes dans le même état pour les deux photos. Pas de flash : il fait briller les taches et fausse les couleurs.' },
    { titre: 'Téléphone à l\'horizontale', detail: 'En format paysage, tenu droit. C\'est ce format que le widget affiche.' },
    { titre: 'Rien dans le cadre', detail: 'Ni produit, ni matériel, ni personne. Seulement l\'objet.' },
];

export function ConsignesPhotoAvantApres({ compact = false }: { compact?: boolean }) {
    return (
        <div className="rounded-xl border border-border bg-surface-soft/60 p-3 space-y-2">
            <p className="flex items-center gap-2 text-[11px] font-bold text-content-muted uppercase tracking-widest">
                <Camera size={13} /> Pour un avant / après qui ressort bien
            </p>
            <ul className={`grid gap-x-4 gap-y-1.5 ${compact ? 'grid-cols-1' : 'grid-cols-1 md:grid-cols-2'}`}>
                {CONSIGNES.map((c) => (
                    <li key={c.titre} className="text-[11px] leading-snug text-content-muted">
                        <b className="text-content">{c.titre}.</b> {c.detail}
                    </li>
                ))}
            </ul>
        </div>
    );
}
